import axios from 'axios';
import CompaniesSearchModel from '../models/CompaniesSearch.model';

export const searchCompany = async (
    query = '',
    items_per_page = 20,
    start_index = 0,
): Promise<CompaniesSearchModel> => {
    const { data } = await axios.get('search/companies', {
        params: { q: query, items_per_page, start_index },
    });
    return data;
};
